export function isMobileDevice() {
  return window.matchMedia('(max-width: 767px)').matches;
}

export function getCurrentBreakpoint(
  width = window.innerWidth,
  breakpoints = {
    mobile: 576,
    tablet: 1024,
  }
) {
  if (width <= breakpoints.mobile) {
    return '576';
  }

  if (width <= breakpoints.tablet) {
    return '1024';
  }

  return '1920';
}

